import SettingLayout from "../SettingLayout";

const AnnouncementIndex = () => {
  return (
    <>
      <SettingLayout hideBtn title="Email Blast"></SettingLayout>
    </>
  );
};

export default AnnouncementIndex;
